import React from 'react';
import ABSIcon from '../ABSIcon';
import classNames from 'classnames';
import './index.less';

export interface IABSIconTextProps {
  icon: string;
  text: string;
  theme?: 'filled' | 'outlined' | 'twoTone';
  style?: React.CSSProperties;
  className?: string;
  isAnt?: boolean;
  containerClassName?: string;
  onClick?: (event: React.MouseEvent<any>) => void;
  fontSize?: 's'|'m'|'l'|'xl';
  type?: 'default' | 'delete' | 'reply';
  disabled?: boolean;
}

export interface IABSIconTextState {

}

class ABSIconText extends React.Component<IABSIconTextProps, IABSIconTextState> {
  onClick = (e: React.MouseEvent<any>) => {
    const { onClick, disabled } = this.props;
    if (!disabled && onClick) {
      onClick(e);
    }
  }
  render() {
    const { className, disabled, isAnt, icon, text, containerClassName, fontSize, theme, style, type } = this.props;
    const fontClassName = fontSize ? `abs-font-${fontSize}` : 'abs-font-m';
    const typeClassName = type ? `abs-btn-${type}` : '';
    const classes = classNames('abs-ant-icon-text', {'icon-text-disabled' : disabled }, containerClassName, fontClassName, typeClassName);
    let iconSize = 14;
    if (fontSize === 's') {
      iconSize = 12;
    } else if (fontSize === 'l') {
      iconSize = 16;
    } else if (fontSize === 'xl') {
      iconSize = 18;
    }
    return (
      <div className={classes} onClick={this.onClick}>
        <ABSIcon size={iconSize} className={className} type={icon} theme={theme} style={style} isAnt={isAnt} />
        <span className="abs-ant-icon-text-title">{text}</span>
      </div>
    );
  }
}

export default ABSIconText;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSIconText/index.tsx